import { useCallback, useEffect, useState } from 'react';

export const RESEND_COOLDOWN_SECONDS = 60;

const useResendCountdown = (seconds = RESEND_COOLDOWN_SECONDS) => {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const timeout = setTimeout(() => { setRemaining((current) => current - 1); }, 1000);
    return () => { clearTimeout(timeout); };
  }, [remaining]);

  const restart = useCallback(() => { setRemaining(seconds); }, [seconds]);

  return { remaining, canResend: remaining <= 0, restart };
};

export default useResendCountdown;
